import 'angular:locale/data:ja';
import 'zone.js';(globalThis.$localize ??= {}).locale = "ja";
